import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import HomeBanner from './HomeBanner'
import SideAdsBanner from './SideAdsBanner'
import HomeAd from './HomeAd'
import SliderSetting from './SliderSetting'
import AuthContext from 'context/AuthContext'

const Ads = () => {
  const { t } = useTranslation()
  const { user } = useContext(AuthContext)
  const manager =
    user?.permission?.find(e => e.manager === 'ads_and_banner_manager') ?? {}
  const [addHomeBanner, setAddHomeBanner] = useState(false)
  const [addSlider, setAddSlider] = useState(false)

  const [defaultTab, setDefaultTab] = useState('side_bar')
  const tabBtnClass =
    'inline-block py-3 px-8 text-md xl:text-lg font-semibold border-b-2'
  const tabActiveClass = 'border-lime-500 text-lime-500'
  const tabBorderNoneClass = 'border-transparent'
  const TAB_SIDE_BAR = 'side_bar'
  const TAB_ADS_AND_BANNER = 'ads_and_banner_manager'
  const TAB_HOME_AD = 'home_ad'
  const TAB_SLIDER_SETTING = 'slider_setting'

  return (
    <>
      <div className='pb-3'>
        <ul className='border-b flex'>
          <li className='mr-0 xl:mr-5'>
            <button
              onClick={() => setDefaultTab(TAB_SIDE_BAR)}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]: defaultTab === TAB_SIDE_BAR,
                [tabBorderNoneClass]: defaultTab !== TAB_SIDE_BAR
              })}
            >
              {t('SIDE_ADDS_MANAGER')}
            </button>
          </li>
          <li className='mx-0 xl:mx-5'>
            <button
              onClick={() => setDefaultTab(TAB_ADS_AND_BANNER)}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]: defaultTab === TAB_ADS_AND_BANNER,
                [tabBorderNoneClass]: defaultTab !== TAB_ADS_AND_BANNER
              })}
            >
              {t('HOME_SCREEN_BANNER')}
            </button>
          </li>
          <li className='mx-0 xl:mx-5'>
            <button
              onClick={() => setDefaultTab(TAB_HOME_AD)}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]: defaultTab === TAB_HOME_AD,
                [tabBorderNoneClass]: defaultTab !== TAB_HOME_AD
              })}
            >
              {t('HOME_AD')}
            </button>
          </li>
          <li className='mx-0 xl:mx-5'>
            <button
              onClick={() => setDefaultTab(TAB_SLIDER_SETTING)}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]: defaultTab === TAB_SLIDER_SETTING,
                [tabBorderNoneClass]: defaultTab !== TAB_SLIDER_SETTING
              })}
            >
              {t('TAB_SLIDER_SETTING')}
            </button>
          </li>
        </ul>
      </div>

      {defaultTab === TAB_SIDE_BAR
        ? (<SideAdsBanner manager={manager} />)
        : defaultTab === TAB_ADS_AND_BANNER ? 
        (<HomeBanner addHomeBanner={{ var: addHomeBanner, fn: setAddHomeBanner }} manager={manager} />)
        : defaultTab === TAB_HOME_AD
        ? (<HomeAd  manager={manager} />)
        :  defaultTab === TAB_SLIDER_SETTING
        ? (<SliderSetting  addSlider={{ var: addSlider, fn: setAddSlider }} manager={manager} />)
        :  null
      }
    </>
  )
}

export default Ads
